import Debug from 'debug';
import { injectable, inject } from 'inversify';
import { reportNonFatalError } from '@/app/error-handling';
import { QueryHandler } from '@/app/tracking/common';
import { QueryBookmarkTrackingQuery, QueryBookmarkTrackingQueryPayload } from '../api';
import { BookmarkDataStoreSymbol, BookmarkDataStore } from './bookmark-data-store'
import { defaultBookmark } from '../api/bookmark-state';

const debug = Debug('query-bookmark-tracking-query-handler');

@injectable()
export class QueryBookmarkTrackingQueryHandler implements QueryHandler<QueryBookmarkTrackingQuery> {
 
  constructor(
    @inject(BookmarkDataStoreSymbol)
    private store: BookmarkDataStore) {
  }

  public async execute(payload: QueryBookmarkTrackingQueryPayload) {

    debug('loading bookmark')
    const loadResult = await this.store.get()
    debug('bookmark result', loadResult)
    if (!loadResult.success) {
      // we have nonrecoverable error
      reportNonFatalError(loadResult.error.code, loadResult.error.details)
      return { bookmark: defaultBookmark() }
    }

    return {
      bookmark: loadResult.value
    }
  }
}
